// extracted by mini-css-extract-plugin
export default {"table":"PreviewCardTable_table__XLDL4","key":"PreviewCardTable_key__5fPU0","value":"PreviewCardTable_value__CgA+G"};